import React from 'react';
import { Inline, xcss } from '@atlaskit/primitives';
import { ContentSlider } from '../../common/ui';

export const ToolbarWrapper = ({
	children,
	show,
}: {
	children: React.ReactNode;
	show: boolean;
}) => (
	<Inline xcss={floatingPositionerStyles} alignBlock="center" alignInline="center">
		<ContentSlider show={show}>{children}</ContentSlider>
	</Inline>
);

const floatingPositionerStyles = xcss({
	position: 'fixed',
	bottom: 'space.100',
	width: '100%',
	left: '0',
	zIndex: 'layer',
});
